import { ApiType } from "@gymflow/common";
import { UserStaffBean } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export async function staffQueryFn({
  api,
  staffId,
}: {
  api: ApiType;
  staffId: string;
}) {
  return (await api.staffApi.findById(staffId)).data;
}

export function useStaff(
  {
    api,
    staffId,
  }: {
    api: ApiType;
    staffId?: string;
  },
  opts?: Omit<UseQueryOptions<UserStaffBean | null>, "queryKey">,
) {
  return useQuery({
    queryKey: staffQueryKeys.details(staffId),
    queryFn: () => staffQueryFn({ api, staffId: staffId! }),
    enabled: !!staffId,
    ...opts,
  });
}
